import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

const fadeInKeyframes = `
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

export default function Home() {
  return (
    <>
      <style>{fadeInKeyframes}</style>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <TopicsSection />
        <AppSection />
        <ContactSection />
        <RankingSection />
        <IndexSection />
        <AboutSection />
        <FeaturesSection />
        <FaqSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}